/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { Wrapper, TitleContainer, Title, CheckBoxText, CheckContainer } from "./styled";
import PayerInputs from "./components/PayerInputs";
import { DATA_PAYER, SAME_DATA } from "../../constants";
import HelpImg from "../../../../../../../images/Icons/help.svg";
import { useDispatch, useSelector } from "react-redux";
import { getTaxPayerData, setDuplicateData } from "../../../../../../../store/Users/actions";
import { contributorData, duplicateData, taxPayerData } from "../../../../../../../store/Users/selectors";
import { isChecked } from "./functions";
import Description from "../Description";

const PayerForm = () => {
  const dispatch = useDispatch();
  const dupData = useSelector(duplicateData);
  const contributor = useSelector(contributorData);
  const payer = useSelector(taxPayerData);

  let disabled = isChecked(contributor);

  const checkboxOnChange = () => {
    dispatch(setDuplicateData());
  };

  useEffect(() => {
    if (payer.cuit !== contributor.cuit) {
      dispatch(getTaxPayerData());
    }
  }, [dupData]);

  return (
    <Wrapper>
      <TitleContainer>
        <Title>{DATA_PAYER}</Title>
        <Description text="Persona que realiza el trámite" />
      </TitleContainer>
      <PayerInputs />
      <CheckContainer>
        <input disabled={disabled} type="checkbox" onChange={checkboxOnChange} checked={dupData} />
        <CheckBoxText disabled={disabled}>{SAME_DATA}</CheckBoxText>
      </CheckContainer>
    </Wrapper>
  );
};

export default PayerForm;
